export default function shallowCompare(
  a: Record<string, any>,
  b: Record<string, any>,
  except: string[] = []
) {
  const allKeys = new Set<string>();
  Object.keys(a).forEach((key) => allKeys.add(key));
  Object.keys(b).forEach((key) => allKeys.add(key));
  except.forEach((key) => allKeys.delete(key));

  return Array.from(allKeys).every((key) => a[key] === b[key]);
}
